import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DictionaryEntryModel, DictionaryResourceService, SaveDictionaryEntriesRequest, SaveDictionaryRequest, SaveEntryRequest } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxDictionaryService {
  constructor(
    private dictionaryResource: DictionaryResourceService,
  ) {
  }

  getEntries(params: {
    key: string;
    query?: string;
    hierarchy? : boolean;
  }): Promise<DictionaryEntryModel[]> {
    return firstValueFrom(this.dictionaryResource.getEntryList(params.key, params.hierarchy, params?.query));
  }

  getEntryByCode(code: string): Promise<DictionaryEntryModel> {
    return firstValueFrom(this.dictionaryResource.getEntryByCode(code));
  }

  saveDictionary(req: SaveDictionaryRequest) {
    return firstValueFrom(this.dictionaryResource.saveDictionary(req));
  }

  getDictionaryList(params?: {
    query?: string;
    page?: number;
    limit?: number;
  }) {
    return firstValueFrom(this.dictionaryResource.getDictionaryList(params?.limit, params?.page, params?.query));
  }

  getDictionaryById(id: number) {
    return firstValueFrom(this.dictionaryResource.getDictionaryById(id));
  }

  removeById(id: number) {
    return firstValueFrom(this.dictionaryResource.removeDictionaryById(id));
  }

  removeEntryByCode(key: string, code: string) {
    return firstValueFrom(this.dictionaryResource.removeDictionaryEntryByCode(key, code));
  }

  setEntryEnabled(key: string, code: string, value: boolean) {
    return firstValueFrom(this.dictionaryResource.setEntryEnabled(code, key, {value: value}));
  }

  saveEntries(id: number, entries: SaveEntryRequest[], parentId?: number) {
    return firstValueFrom(this.dictionaryResource.saveEntries(id, {entries: entries, parentId: parentId}));
  }

  saveNewEntry(id: number, entry: SaveDictionaryEntriesRequest) {
    return firstValueFrom(this.dictionaryResource.saveNewEntry(id, entry));
  }


}
